import { render, staticRenderFns } from "./formPenilaianPelaksanaanPusat.vue?vue&type=template&id=af8ef378&"
import script from "./formPenilaianPelaksanaanPusat.vue?vue&type=script&lang=js&"
export * from "./formPenilaianPelaksanaanPusat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports